module.exports = __webpack_public_path__ + "assets/images/magenta_sport_1_league.5bcd84269e44fbb2e4d3a59add1a930f.png";